<template>
  <div>
    <vx-card title="Счет" class="p-6 mb-5">
      <div class="vx-row">
        <div class="vx-col flex-1">
          <table>
            <tr>
              <td class="font-semibold">Дата создания счета</td>
              <td class="pl-4">
                <span class="text-primary">{{ bill.date_created }}</span>
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Дата оплаты счета</td>
              <td class="pl-4">
                <span v-if="bill.is_paid" class="text-primary">{{
                  bill.date_payed
                }}</span>
                <span v-else class="text-warning">Счет еще оплачен</span>
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Сумма</td>
              <td class="pl-4">
                <span class="text-primary">{{ bill.price }} руб.</span>
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Сумма коммунальных платежей</td>
              <td class="pl-4">
                <span class="text-primary">{{ bill.communal }} руб.</span>
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Адрес</td>
              <td class="pl-4">
                <p>
                  <span class="text-primary">{{
                    bill.home.county_type.name
                  }}</span
                  >, участок #
                  <span class="text-primary">{{
                    bill.home.homestead_number
                  }}</span
                  >, ул.
                  <span class="text-primary">{{ bill.home.address }}</span>
                </p>
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Оплачен</td>
              <td class="pl-4">
                <span
                  class="font-semibold"
                  :class="{
                    'text-success': bill.is_paid,
                    'text-danger': !bill.is_paid,
                  }"
                  >{{ bill.is_paid ? "Да" : "Нет" }}</span
                >
              </td>
            </tr>
            <tr v-if="bill.description">
              <td class="font-semibold">Примечание</td>
              <td class="pl-4">
                <span class="text-primary">{{ bill.description }}</span>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <template slot="footer">
        <vs-button @click="popupDeleteComfirm = true" color="danger">
          Удалить
        </vs-button>
      </template>
    </vx-card>

    <vx-card title="Платные услуги" class="p-6 h-full">
      <template v-if="bill && bill.services.length">
        <vs-list>
          <vs-list-item
            v-for="(item, index) in bill.services"
            :key="index"
            :title="`${index + 1}. Название: ${item.name}. Цена: ${
              item.amount
            } руб`"
            :subtitle="item.comment"
          >
            <vx-tooltip class="inline-block" text="Открыть">
              <vs-button
                :href="`/paid-services/${item.id}`"
                icon-pack="feather"
                icon="icon-external-link"
                color="danger"
                size="small"
              ></vs-button>
            </vx-tooltip>
          </vs-list-item>
        </vs-list>
      </template>
      <template v-else> Список платных услуг пуст </template>
    </vx-card>

    <vs-popup
      v-if="bill"
      title="Вы действительно хотите удалить?"
      :active.sync="popupDeleteComfirm"
    >
      <p class="font-semibold mb-5">
        Счет #<span class="text-danger text-lg">{{ bill.id }}</span>
        будет удален безвозвратно
      </p>
      <vs-button @click="deleteBill" color="danger" class="mr-5" type="filled"
        >Удалить</vs-button
      >
      <vs-button @click="popupDeleteComfirm = false" color="dark" type="border"
        >Отмена</vs-button
      >
    </vs-popup>
  </div>
</template>
<script>
import { API_URL, countyType } from "@/.env";
import { DateTime } from "luxon";

export default {
  data: () => ({
    BASE_URL: API_URL,
    bill: null,

    popupDeleteComfirm: false,
  }),
  components: {
    DateTime,
  },
  watch: {},
  computed: {},
  methods: {
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    getBill() {
      this.$load(async () => {
        let res = (
          await this.$api.communalPayments.getInvoice(this.$route.params.id)
        ).data;

        res.home.county_type = countyType.find(
          (x) => x.id == res.home.county_type
        );

        res.date_created = DateTime.fromISO(res.date_created).toFormat(
          "dd.MM.yyyy"
        );

        if (res.date_payed) {
          res.date_payed = DateTime.fromISO(res.date_payed).toLocaleString(
            DateTime.DATETIME_SHORT
          );
        }

        this.bill = res;
      });
    },
    deleteBill() {
      this.$load(async () => {
        await this.$api.communalPayments
          .deleteInvoice(this.$route.params.id)
          .then((response) => {
            if (response.status == 200) {
              this.popupDeleteComfirm = false;
              this.notification("Успешно", "Счет удален", "success");
              this.$router.push({ name: "communal-payments-bills" });
            } else {
              this.notification("Ошибка", "Не удалось удалить счет", "danger");
            }
          });
      });
    },
  },
  mounted() {
    this.getBill();
  },
};
</script>